__turbopack_context__.v({
  "activeSection": "About-module-scss-module__647jFG__activeSection",
  "calendarTable": "About-module-scss-module__647jFG__calendarTable",
  "cookiePolicyTable": "About-module-scss-module__647jFG__cookiePolicyTable",
  "faqBonus": "About-module-scss-module__647jFG__faqBonus",
  "faqContainer": "About-module-scss-module__647jFG__faqContainer",
  "faqImage": "About-module-scss-module__647jFG__faqImage",
  "faqList": "About-module-scss-module__647jFG__faqList",
  "htmlContainer": "About-module-scss-module__647jFG__htmlContainer",
  "lastUpdateText": "About-module-scss-module__647jFG__lastUpdateText",
  "walletSection": "About-module-scss-module__647jFG__walletSection",
});
